// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './common.module';
export * from './directives';
export * from './pipes';
// @endindex